module.exports = __webpack_public_path__ + "static/media/administration_main-accounts_add.60c7e497.svg";